import { useEffect, useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import LeftPanel from './components/LeftPanel';
import RightPanel from './components/RightPanel';
import { NetworkProvider } from './contexts/NetworkContext';
import { TabProvider } from './contexts/TabContext';
import FullscreenVisualiseView from './components/RightPanel/FullscreenVisualiseView';

import 'react-data-grid/lib/styles.css';

function App() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [graphData, setGraphData] = useState<{
    nodes: any[];
    edges: any[];
    selectedCouriers: string[];
  }>({ nodes: [], edges: [], selectedCouriers: [] });

  useEffect(() => {
    // Check if fullscreen mode is requested via URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const fullscreenMode = urlParams.get('fullscreen') === 'true';
    setIsFullscreen(fullscreenMode);

    // If fullscreen mode, load data from sessionStorage
    if (fullscreenMode) {
      const storedData = sessionStorage.getItem('fullscreenGraphData');
      if (storedData) {
        try {
          const data = JSON.parse(storedData);
          setGraphData(data);
        } catch (e) {
          console.error('Failed to parse graph data:', e);
        }
      }
    }
  }, []);

  // Render fullscreen view if requested
  if (isFullscreen) {
    return (
      <div className="w-screen h-screen overflow-hidden">
        <FullscreenVisualiseView
          initialNodes={graphData.nodes}
          initialEdges={graphData.edges}
        />
      </div>
    );
  }

  // Normal app layout
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />

      <NetworkProvider>
        <TabProvider>
          <main className="flex-grow container mx-auto px-4 py-8">
            <div className="flex gap-6 h-full">
              {/* Left Panel - smaller */}
              <div className="w-1/4">
                <LeftPanel />
              </div>

              {/* Right Panel - main content */}
              <div className="w-3/4">
                <RightPanel />
              </div>
            </div>
          </main>
        </TabProvider>
      </NetworkProvider>

      <Footer />
    </div>
  );
}

export default App;
